import { useMemo } from "react";
import { useMasterStudyService } from "../modules/Clinical/StudyDetails/api/useStudyQuery";

export const addMinutesToTime = (timeStr: string, minutesToAdd: number) => {
  if (!timeStr) return timeStr;
  const match = timeStr.match(/(\d+):(\d+)\s*(AM|PM)?/i);
  if (!match) return timeStr;
  let [_, hStr, mStr, ampm] = match;
  let h = parseInt(hStr, 10);
  let m = parseInt(mStr, 10);

  if (ampm) {
    if (ampm.toUpperCase() === 'PM' && h < 12) h += 12;
    if (ampm.toUpperCase() === 'AM' && h === 12) h = 0;
  }

  m += minutesToAdd;
  h += Math.floor(m / 60);
  m = Math.round(m % 60);
  h = ((h % 24) + 24) % 24;

  let newAmpm = h >= 12 ? 'PM' : 'AM';
  let newH = h % 12;
  if (newH === 0) newH = 12;

  return `${newH.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")} ${newAmpm}`;
};

export const useStudyTimepoints = (studyId: number) => {
  const { SelectQuery } = useMasterStudyService({ id: studyId, enabledSelect: true });
  const { data: studyResponse, isLoading, isFetching } = SelectQuery;
  const apiStudy = studyResponse?.data?.[0] || {};
  console.log("apiStudy", apiStudy);

  const dosingTimeStr = apiStudy.dosingtime;
  const subjectInterval = Number(apiStudy.subjectinterval);
  const predoseWindowMinutes = Number(apiStudy.predosewindowminutes ?? apiStudy.predose_window_minutes ?? 0);

  const dynamicPeriods = useMemo(() => {
    if (apiStudy.periods && Array.isArray(apiStudy.periods)) {
      return apiStudy.periods.map((p: any, index: number) => {
        const pNo = p.period_no || index + 1;
        const periodLetter = String.fromCharCode(64 + pNo);
        return {
          periodid: p.period_id || pNo,
          periodname: `Treatment Period ${periodLetter}`,
          periodcode: `PER-${periodLetter}`,
          periodorder: pNo,
          isactive: true,
        };
      });
    }
    return [];
  }, [apiStudy.periods]);

  const dynamicPhases = useMemo(() => {
    const rawTimepoints = Array.isArray(apiStudy.samplingpoints)
      ? apiStudy.samplingpoints
      : typeof apiStudy.samplingpoints === "string"
        ? apiStudy.samplingpoints.split(",").map((s: string) => s.trim())
        : [];

    return rawTimepoints.map((sp: string, index: number) => {
      const val = parseFloat(sp);
      const offsetMin = isNaN(val) ? 0 : val * 60;
      const actualTime = addMinutesToTime(dosingTimeStr, offsetMin);

      return {
        timepointid: index + 1,
        label: sp,
        actualTime: actualTime,
        offset: offsetMin,
      };
    });
  }, [apiStudy.samplingpoints, dosingTimeStr]);

  return {
    apiStudy,
    isLoading,
    isFetching,
    dosingTimeStr,
    subjectInterval,
    predoseWindowMinutes,
    dynamicPeriods,
    dynamicPhases,
    addMinutesToTime
  };
};
